import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "src/Hooks/useReactQuery";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import LoadingWrapper from "src/components/Common/Table/Loading";
import { getCasesResult6DOF } from "src/services/simulator-gnc";
import classNames from "classnames";

const ModalCaseResult = ({ id, closeModal, isOpen }) => {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation(["gnc-simulator-6dof", "common"]);
  const KEY_NOT_SHOW = ["input_file_id", "case_id"];

  const { data } = useQuery(
    [`getCasesResult6Dof_${id}`],
    () =>
      getCasesResult6DOF({
        id,
      }),
    {
      onSuccess: () => {},
      onSettled: () => setLoading(false),
    }
  );

  const filterKeys = data?.length > 0 ? Object.keys(data[0]).filter((key) => data.some((row) => typeof row[key] !== "object")) : [];

  return (
    <Modal centered isOpen={isOpen} toggle={closeModal} className="modal-full-width" backdrop="static">
      <ModalHeader className="p-b-0" toggle={closeModal}>
        {t("list.table.result_button")}
      </ModalHeader>
      <ModalBody className="overflow-auto max-vh-85 p-0 m-a-16">
        <LoadingWrapper loading={loading}>
          <div className={classNames("react-bootstrap-table w-100 h-100 max-vh-85", { "min-height-by-px-110": loading })}>
            <table className="table table-striped table-hover table-bordered mb-0 table-collapse">
              <thead className="table-secondary">
                <tr>
                  {filterKeys?.map((key, index) => {
                    if (KEY_NOT_SHOW.includes(key)) return <Fragment key={index}></Fragment>;
                    return (
                      <th key={index}>
                        <div className="text-nowrap">{key}</div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {data?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {filterKeys?.map((key, colIndex) => {
                      if (KEY_NOT_SHOW.includes(key)) return <Fragment key={colIndex}></Fragment>;
                      return (
                        <td key={colIndex} className="text-nowrap">
                          {`${row[key]}`}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </LoadingWrapper>
      </ModalBody>
    </Modal>
  );
};

export default ModalCaseResult;
